import { TuiTooltip } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { WorkflowFormFieldOutputTextPopulated } from '@features/requests/request-form/components/request-form-workflows/types';
import { TuiHint, TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'x-output-text-field',
  imports: [TuiHint, TuiTooltip, TuiIcon],
  templateUrl: './output-text-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class OutputTextFieldComponent {
  field = input.required<WorkflowFormFieldOutputTextPopulated>();
}
